import { render, staticRenderFns } from "./autoChats.vue?vue&type=template&id=2d64d75f&scoped=true"
import script from "./autoChats.vue?vue&type=script&lang=js"
export * from "./autoChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64d75f",
  null
  
)

export default component.exports